import { render } from "./meta-data-edit-page.vue?vue&type=template&id=d6d85886"
import script from "./meta-data-edit-page.vue?vue&type=script&lang=js"
export * from "./meta-data-edit-page.vue?vue&type=script&lang=js"

import exportComponent from "/Users/andrew/Documents/Code/SeoBiz/AdminApp/FrontEnd/clientapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__